import './styles/reviewChart.scss'
import React, {useMemo} from 'react';
import {Loader, remToPx} from '@dvrd/dvr-controls';
import IDate from '@dvrd/idate';
import {ApexBarSerie, ReviewChartData} from "../../../util/interfaces";
import Chart from "react-apexcharts";

interface Props {
    chartData: Record<string, ReviewChartData>;
    loading: boolean;
}

export default function ReviewChart(props: Props) {
    const {chartData, loading} = props;
    const [series, options] = useMemo(() => {
        const xLabels: Set<string> = new Set();
        const positive: Array<number> = [];
        const negative: Array<number> = [];
        for (let [label, values] of Object.entries(chartData)) {
            const momentLabel = new IDate(label);
            if (momentLabel.isAt(new IDate(), 'year')) label = momentLabel.format('MMM');
            else label = momentLabel.format('MMM \'YY');
            xLabels.add(label);
            positive.push(values.positive);
            negative.push(values.negative);
        }
        const series: Array<ApexBarSerie> = [
            {name: 'Positief', data: positive},
            {name: 'Negatief', data: negative},
        ];
        const options = {
            chart: {
                toolbar: {show: false},
                zoom: {enabled: false},
            },
            colors: ['#29A71A', '#EF2525'],
            xaxis: {
                type: 'category' as 'category',
                tickAmount: 15,
                categories: Array.from(xLabels),
                labels: {
                    rotate: -45,
                    rotateAlways: true,
                },
            },
            yaxis: {min: 0},
            legend: {
                markers: {
                    customHTML: function() {
                        return '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" class="svg-inline--fa fa-check legend-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">' +
                            '<path fill="currentColor" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>' +
                            '</svg>'
                    }
                }
            },
            stroke: {
                curve: 'smooth' as 'smooth',
            },
            dataLabels: {enabled: false},
        }
        return [series, options];
    }, [chartData]);

    return (
        <div className='reviews-chart'>
            <Loader active={loading}/>
            <Chart options={options} series={series} type='area' height='100%'/>
        </div>
    )
}